import { makeSelectors } from '@utils/css';
import { toolbarCls } from './molecule.toolbar.style.js';

const POSTLOADED_TRANSITION_DURATION_MS = 375;
const wrapper = "dibw2uiwql";
const container = "dibcp8q6xv";
const throbber = "dibt1elx86w";
const content = "dibc1e82bsg";
const postloadedModalSelectors = makeSelectors({
  container,
  content,
  toolbar: toolbarCls
});

export { POSTLOADED_TRANSITION_DURATION_MS, container, content, postloadedModalSelectors, throbber, wrapper };
import "./organism.content.style.linaria.module.css";
//# sourceMappingURL=organism.content.style.js.map
